var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0587 14.0065L28.2262 1.83892C28.6469 1.41821 28.6469 0.736143 28.2262 0.315436C27.8054 -0.105145 27.1234 -0.105145 26.7027 0.315436L13.7734 13.2447C13.3529 13.6654 13.3529 14.3475 13.7734 14.7682L26.7027 27.6975C27.1308 28.1109 27.8128 28.099 28.2262 27.671C28.6294 27.2534 28.6294 26.5915 28.2262 26.174L16.0587 14.0065Z",
    fill: "#00683A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05867 14.0065L21.2262 1.83892C21.6469 1.41821 21.6469 0.736143 21.2262 0.315436C20.8054 -0.105145 20.1234 -0.105145 19.7027 0.315436L6.77344 13.2447C6.35286 13.6654 6.35286 14.3475 6.77344 14.7682L19.7027 27.6975C20.1308 28.1109 20.8128 28.099 21.2262 27.671C21.6294 27.2534 21.6294 26.5915 21.2262 26.174L9.05867 14.0065Z",
    fill: "#00683A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLeftArrow);
export default __webpack_public_path__ + "static/media/double-left-arrow.462f48b1.svg";
export { ForwardRef as ReactComponent };